import {  magazine } from '../actions/constants'

const initState = {
    loading: false,
    magazine: [],
};

export default (state = initState, action) => {

    switch (action.type) {

        case magazine.GET_MAGAZINE_REQUEST:
            state = {
                ...state,
                loading: true
            };
            break;

        case magazine.GET_MAGAZINE_SUCCESS:
            state = {
                ...state,
                magazine: action.payload.magazine,
                loading: false
            };
            break;

        case magazine.GET_MAGAZINE_FAILURE:
            state = {
                ...initState,
            };
            break;
    }
    return state
};
